import React from 'react';
import './style.css';


function DailyMotionFrame() {
    const serachParams = new URLSearchParams(window.location.search);

    const url = `https://www.dailymotion.com/embed/video/${serachParams.get("videoId")}?autoplay=1`;

    console.log(url);
    return (
        <div class="videoWrapper">
            <iframe frameborder="0" width="640" height="360"
                src={url}
                allowfullscreen
                allow="autoplay; fullscreen; picture-in-picture">
            </iframe>
        </div>
    );
}

export default DailyMotionFrame;